import React from 'react';
import { GoalStatusCard } from '../GoalStatusCard/GoalStatusCard';
import { GoalBase, GoalId, GoalViewBy } from '../types';
import { getGroupName, groupGoals } from './groupLogic';

type Props = {
  goals: GoalBase[];
  onGoalClick: (goalId: GoalId) => void;
  viewBy: GoalViewBy;
};

export const GoalsList: React.FC<Props> = ({ goals, onGoalClick, viewBy }) => {
  const groupedGoals = groupGoals(goals, viewBy);
  return (
    <div>
      {Array.from(groupedGoals.entries()).map(([groupKey, curGroupGoals]) => {
        const groupDescription =
          viewBy === 'category'
            ? curGroupGoals[0]?.category?.description ?? undefined
            : undefined;
        return (
          <GoalStatusCard
            key={groupKey}
            groupName={getGroupName(groupKey)}
            groupDescription={groupDescription}
            goals={curGroupGoals}
            onGoalClick={onGoalClick}
          />
        );
      })}
    </div>
  );
};
